import { onCleanup } from "solid-js";

type Subscription<T> = (payload: T) => void;

export type Subscriber<T> = (callback: Subscription<T>) => void;
export type Publisher<T> = (payload: T) => void;

export function createPublisher<T>(): [
    subscribe: Subscriber<T>,
    publish: Publisher<T>
] {
    const subscriptions = new Set<Subscription<T>>();

    const subscribe = (callback: Subscription<T>) => {
        subscriptions.add(callback);
        const unsubscribe = () => subscriptions.delete(callback);
        onCleanup(unsubscribe);
    };

    const publish = (payload: T) => {
        for (const callback of subscriptions) {
            callback(payload);
        }
    };

    return [subscribe, publish];
}
